export const chartStoreUrl = 'chartmanager.raymarine.com';
export const supportUrl = 'https://teledyneflir.my.site.com/';
export const webHelpEmail = 'webhelp@flir.com';
export const tollFreeNumber = '1-800-254-0630';
export const s63RaymarineEmail = 'S63@Raymarine.com';
export const custHelp = 'https://teledyneflir.my.site.com/';
export const tidesandcurrentsLink = 'https://tidesandcurrents.noaa.gov/datum_options.html';
export const cssLink = 'text-decoration: none;color: #861F41;';

export const CONFIG_NOTFOUND = {
  supportUrl,
  cssLink: 'text-decoration: underline;color: black;'
};

export const CONFIG_CONTACTUS = {
  supportUrl,
  cssContact: 'text-decoration: underline; color: #FF1F00;'
};

export const CONFIG_BILLING_PAYMENT_SUPPORT = {
  webHelpEmail,
  tollFreeNumber,
  custHelp,
  tidesandcurrentsLink,
  cssLink
};

export const CONFIG_S63RAYMARINE_SUPPORT = {
  s63RaymarineEmail,
  cssLink
};
